import { useQuery } from '@tanstack/react-query';
import { pb } from '@/core/api';

export type RaceBonusLeader = {
  id: string;
  first_name: string;
  photo: string;
  count: number;
};

export type RaceBonusWinner = {
  id: string;
  first_name: string;
  photo: string;
  achieved_at: string;
};

export type RaceCycleType = 'daily' | 'weekly' | 'monthly';

export type RaceBonusEntry = {
  cycle_type: RaceCycleType;
  slug: string;
  threshold: number;
  amount_eur: number;
  cycle_start: string;
  cycle_end: string;
  cycle_end_iso: string;
  winner: RaceBonusWinner | null;
  your_progress: number;
  leader: RaceBonusLeader | null;
};

type RaceBonusResponse = { races: RaceBonusEntry[] };

export function useRaceBonusCurrent() {
  return useQuery({
    queryKey: ['race-bonus', 'current'],
    queryFn: async (): Promise<RaceBonusResponse> =>
      pb.send('/api/race-bonus/current', { method: 'GET' }),
    staleTime: 30_000,
  });
}
